import { z } from 'zod'
import { Temporal } from '@js-temporal/polyfill'
import type { OpeningHour } from '../../models/OpeningHour'
import { Weekday } from '~/shared/weekly-periods/models/Weekday'
import type { WeeklyPeriods } from '~/shared/weekly-periods/models/WeeklyPeriods'
import { useEmptyWeeklyPeriods } from '~/shared/weekly-periods/composables/useEmptyWeeklyPeriods'

export const OpeningHourDTO = z.object({
  week_day: z.nativeEnum(Weekday),
  time_start: z.string(),
  time_end: z.string()
})

export type OpeningHourDTO = z.infer<typeof OpeningHourDTO>

export function mapOpeningHourToDTO (model: OpeningHour): OpeningHourDTO {
  return {
    week_day: model.weekDay,
    time_start: model.start,
    time_end: model.end
  }
}

export function mapDTOToOpeningHour (dto: OpeningHourDTO): OpeningHour {
  return {
    weekDay: dto.week_day,
    start: dto.time_start,
    end: dto.time_end
  }
}

export function mapWeeklyPeriodsToOpeningHours (periods: WeeklyPeriods): OpeningHour[] {
  const openingHours: OpeningHour[] = []

  for (const [weekday, shifts] of Object.entries(periods)) {
    shifts.forEach((shift) => {
      openingHours.push({
        weekDay: parseInt(weekday, 10) as Weekday,
        start: shift.start.toString({ smallestUnit: 'minute' }),
        end: shift.end.toString({ smallestUnit: 'minute' })
      })
    })
  }

  return openingHours
}

export function mapOpeningHoursToWeeklyPeriods (openingHours: OpeningHour[]): WeeklyPeriods {
  const weeklyPeriods: WeeklyPeriods = useEmptyWeeklyPeriods()

  for (const openingHour of openingHours) {
    weeklyPeriods[openingHour.weekDay].push({
      start: Temporal.PlainTime.from(openingHour.start),
      end: Temporal.PlainTime.from(openingHour.end)
    })
  }

  return weeklyPeriods
}
